export default "__VITE_ASSET__Dbp0dcdn__"